export default {
  KYC_REVIEW: 'A date when the profile will be flagged for a KYC review, usually tied to expiring documents',
  ASSIGNED_USER: 'User assigned to handle and review this Entity',
  RISK_LEVEL: 'Manually assigned level of risk, used for your internal risk assessment',
  ISSUES: 'Number of potential issues that require attention and manual review',
  STATUS_CHANGE: 'Set status to Accepted to reflect changes in the profile.',
  REVERT_RISK_LEVEL: 'Revert Risk Level to Automatic',
};
